import View from './SalesEditor'

export default View
